import { SimpleDate } from '@app/core/domain';

export enum UserWarning {
  TOO_YOUNG = 'TOO_YOUNG',
  EMPTY_BIRTHDAY = 'EMPTY_BIRTHDAY',
  MARKETING_CONSENT = 'MARKETING_CONSENT',
}

export interface UserResponse {
  id: string;
  oktaId: string;
  name: string;
  email: string;
  givenName: string;
  familyName: string;
  birthDate: string;
  phoneNumber: string;
  containsPlcCard: boolean;
  countryCode: string;
  lang: string;
  warnings: Array<'TOO_YOUNG' | 'EMPTY_BIRTHDAY' | 'MARKETING_CONSENT'>;
}

export interface User {
  id: string;
  oktaId: string;
  name: string;
  email: string;
  firstName: string;
  lastName: string;
  birthDate: SimpleDate;
  phone: string;
  containsPlcCard: boolean;
  countryCode: string;
  lang: string;
  warning: UserWarning;
}
